import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import NotificationEmailModal from './NotificationEmailModal';
import { getNotificationEmailFromNetProfile } from '../../utils/userEmail';
import { getDoctorInterestsStorageKey } from './DoctorInterestsModal';
import { authService } from '../../services/authService';
import { tokenUtils } from '../../utils/tokenUtils';

const NotificationEmailGate = () => {
  const {
    user,
    setUser,
    usuarioConCedula,
    isLoadingUsuario,
    refreshUsuarioConCedula,
  } = useAuth();
  const [showModal, setShowModal] = useState(false);
  /** Evita reabrir la modal en la misma sesión tras guardar o decidir que no aplica. */
  const dismissedRef = useRef(false);

  const userKey = user ? `${user.cedula || ''}:${user.authSource || ''}` : null;
  const localUserId = usuarioConCedula?.id ?? null;
  const authSource = user?.authSource;
  const hasCedula = Boolean(user?.cedula);

  useEffect(() => {
    dismissedRef.current = false;
    setShowModal(false);
  }, [userKey]);

  useEffect(() => {
    if (!userKey) {
      setShowModal(false);
      return;
    }

    // Esperar sync local sin cerrar/abrir en falso (antes esto hacía flash).
    if (hasCedula && isLoadingUsuario) {
      return;
    }

    if (dismissedRef.current) {
      return;
    }

    let cancelled = false;

    (async () => {
      const token = tokenUtils.get();
      if (!token || tokenUtils.isExpired(token)) {
        if (!cancelled) setShowModal(false);
        return;
      }

      let apiUser = null;
      try {
        apiUser = await authService.fetchNetUserProfile(localUserId);
      } catch {
        apiUser = null;
      }

      if (cancelled || dismissedRef.current) return;

      // Fetch fallido/transitorio: no abrir la modal (evita aparecer/desaparecer).
      if (!apiUser) {
        return;
      }

      const email = getNotificationEmailFromNetProfile(apiUser);
      if (email) {
        setShowModal(false);
        return;
      }

      const needsDoctorInterests =
        authSource === 'habeas-data' &&
        localUserId &&
        localStorage.getItem(getDoctorInterestsStorageKey(localUserId)) !== 'true';

      if (needsDoctorInterests) {
        setShowModal(false);
        return;
      }

      setShowModal(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [userKey, localUserId, isLoadingUsuario, hasCedula, authSource]);

  const handleSuccess = () => {
    dismissedRef.current = true;
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <NotificationEmailModal
      open={showModal}
      onSuccess={handleSuccess}
      user={user}
      setUser={setUser}
      refreshUsuarioConCedula={refreshUsuarioConCedula}
    />
  );
};

export default NotificationEmailGate;
